import { useBreadcrumb } from '../hooks/useBreadcrumb';

type BreadcrumbContainerProps = { children: React.ReactNode };

const BreadcrumbContainer = ({ children }: BreadcrumbContainerProps) => {
	const { blockClass, componentId } = useBreadcrumb();

	const renderClass = () => {
		return blockClass && `container--${blockClass} vtex-breadcrumb-1-x-container--${blockClass}`;
	};

	return (
		<div data-selection={componentId} className={`container vtex-breadcrumb-1-x-container pv3 ${renderClass()}`}>
			{children}
		</div>
	);
};

export default BreadcrumbContainer;
